module.exports = __webpack_public_path__ + "static/media/6512.ebd1ea32.jpg";